export interface IButtonClaims {
    claims: string[],
    component: any,
}

export const filterByClaims = (btn: IButtonClaims, userClaims: string[]) => {
    return btn.claims?.length > 0 ? btn.claims.filter((claim: any) => userClaims.includes(claim)).length > 0 : true;
}